// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__39wWR","container":"styles_container__3eum5","title":"styles_title__3x1ol","wrapper":"styles_wrapper__2hk17","answer":"styles_answer__17wMx"};